/* eslint-disable */
import "./style.sass";

window.DatoCmsPlugin.init((plugin) => {
  plugin.startAutoResizer();
  const unsubscribe = plugin.addFieldChangeListener(
    plugin.parameters.instance.selectedField,
    (newValue) => {
      plugin.setFieldValue(plugin.fieldPath, newValue[0]);
      console.log(newValue[0]);
    }
  );
  unsubscribe();
});
